'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Checkbox } from '@/shared/components/ui';
import { FeatherClock, FeatherLayers, FeatherMessageCircle, FeatherPause, FeatherPlay, FeatherUser } from '@subframe/core';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { NegociacaoLoteCardProps } from '../../types/lote.types';
export function NegociacaoLoteCard(t0) {
  const $ = _c(72);
  const {
    item,
    isSelected,
    onToggleSelect,
    onClick,
    onPauseClick,
    onResumeClick,
    colorClass,
    bgClass,
    borderClass
  } = t0;
  const handleCheckboxClick = _temp;
  let t1;
  if ($[0] !== item.id) {
    t1 = (e_0, action) => {
      e_0.stopPropagation();
      action(item.id);
    };
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleActionClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Date().getTime();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.createdAt) {
    t3 = new Date(item.createdAt).getTime();
    $[3] = item.createdAt;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const daysOpen = Math.floor((t2 - t3) / 86400000);
  const t4 = `group relative flex cursor-pointer flex-col gap-3 rounded-xl border bg-white p-4 transition-all hover:shadow-md ${isSelected ? `${borderClass} border-2` : "border-neutral-200"}`;
  let t5;
  if ($[5] !== item.id || $[6] !== onToggleSelect) {
    t5 = () => onToggleSelect(item.id);
    $[5] = item.id;
    $[6] = onToggleSelect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `Selecionar ${item.negotiationName}`;
  let t7;
  if ($[8] !== isSelected || $[9] !== t5 || $[10] !== t6) {
    t7 = <div onClick={handleCheckboxClick}><Checkbox checked={isSelected} onCheckedChange={t5} aria-label={t6} /></div>;
    $[8] = isSelected;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== item.client) {
    t8 = <h3 className="text-body-bold font-body-bold text-default-font line-clamp-1">{item.client}</h3>;
    $[12] = item.client;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== item.type) {
    t9 = item.type === "Individual" ? <FeatherUser className="h-4 w-4 text-neutral-500" /> : <FeatherLayers className="h-4 w-4 text-neutral-500" />;
    $[14] = item.type;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="flex items-center gap-2">{t8}{t9}</div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== item.negotiationName) {
    t11 = <p className="text-caption font-caption text-subtext-color line-clamp-1">{item.negotiationName}</p>;
    $[19] = item.negotiationName;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className="flex flex-col gap-1">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t7) {
    t13 = <div className="flex items-start gap-3">{t7}{t12}</div>;
    $[24] = t12;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== item.status || $[28] !== item.statusVariant) {
    t14 = <Badge variant={item.statusVariant} className="shrink-0">{item.status}</Badge>;
    $[27] = item.status;
    $[28] = item.statusVariant;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t13 || $[31] !== t14) {
    t15 = <div className="flex items-start justify-between gap-3">{t13}{t14}</div>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = `flex items-center gap-1 rounded-full px-2 py-1 ${bgClass}`;
  const t17 = `text-caption-bold font-caption-bold ${colorClass}`;
  let t18;
  if ($[33] !== item.temperature || $[34] !== t17) {
    t18 = <span className={t17}>{item.temperature}</span>;
    $[33] = item.temperature;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t18) {
    t19 = <div className={t16}>{t18}</div>;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== item.needsAction) {
    t20 = item.needsAction && <div className="bg-warning-50 flex items-center gap-1 rounded-full px-2 py-1"><span className="text-caption-bold font-caption-bold text-warning-600">Ação necessária</span></div>;
    $[39] = item.needsAction;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== daysOpen) {
    t21 = daysOpen > 0 && <div className="flex items-center gap-1 text-neutral-500"><FeatherClock className="h-3 w-3" /><span className="text-caption font-caption">{daysOpen}d</span></div>;
    $[41] = daysOpen;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t19 || $[44] !== t20 || $[45] !== t21) {
    t22 = <div className="flex flex-wrap items-center gap-2">{t19}{t20}{t21}</div>;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== item.objective || $[48] !== item.objectiveValue) {
    t23 = item.objectiveValue && <div className="flex items-center justify-between rounded-lg bg-neutral-50 px-3 py-2"><span className="text-caption font-caption text-subtext-color">Objetivo:</span><span className="text-body-bold font-body-bold text-default-font">{item.objective}</span></div>;
    $[47] = item.objective;
    $[48] = item.objectiveValue;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== item.pendency) {
    t24 = item.pendency && <div className="border-warning-200 bg-warning-50 flex items-start gap-2 rounded-lg border px-3 py-2"><FeatherMessageCircle className="text-warning-600 h-4 w-4 shrink-0" /><p className="text-caption font-caption text-warning-700 line-clamp-2">{item.pendency}</p></div>;
    $[50] = item.pendency;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== item.createdAt) {
    t25 = formatDistanceToNow(new Date(item.createdAt), {
      addSuffix: true,
      locale: ptBR
    });
    $[52] = item.createdAt;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t25) {
    t26 = <span className="text-caption font-caption text-subtext-color">{t25}</span>;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== handleActionClick || $[57] !== item.isPaused || $[58] !== onPauseClick || $[59] !== onResumeClick) {
    t27 = <div className="flex items-center gap-2">{item.isPaused ? <Button variant="neutral-tertiary" size="small" icon={<FeatherPlay className="h-4 w-4" />} onClick={e_1 => handleActionClick(e_1, onResumeClick)}>Retomar</Button> : <Button variant="neutral-tertiary" size="small" icon={<FeatherPause className="h-4 w-4" />} onClick={e_2 => handleActionClick(e_2, onPauseClick)}>Pausar</Button>}</div>;
    $[56] = handleActionClick;
    $[57] = item.isPaused;
    $[58] = onPauseClick;
    $[59] = onResumeClick;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t26 || $[62] !== t27) {
    t28 = <div className="flex items-center justify-between gap-2 border-t border-neutral-100 pt-3">{t26}{t27}</div>;
    $[61] = t26;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== onClick || $[65] !== t15 || $[66] !== t22 || $[67] !== t23 || $[68] !== t24 || $[69] !== t28 || $[70] !== t4) {
    t29 = <div className={t4} onClick={onClick}>{t15}{t22}{t23}{t24}{t28}</div>;
    $[64] = onClick;
    $[65] = t15;
    $[66] = t22;
    $[67] = t23;
    $[68] = t24;
    $[69] = t28;
    $[70] = t4;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  return t29;
}
function _temp(e) {
  e.stopPropagation();
}